import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

export default function API_Call_Handler() {
  const { logout } = useAuth0();
  const returnTo = window.location.origin;

  async function apiCall({
    url,
    headers = {},
    method,
    data = {},
    responseType = "json",
    onUploadProgress = undefined,
  }) {
    try {
      const response = await axios({
        url,
        headers,
        method,
        data,
        responseType,
        onUploadProgress,
      });
      return {
        error: false,
        data: response.data,
        headers: response.headers,
        status: response.status,
      };
    } catch (error) {
      if (error.response?.status === 403) logout({ returnTo });
      console.error("API error: ", error);
      return {
        error: true,
        status: error.response?.status,
        message: error.response?.data?.message,
        details: error.response?.data?.details,
      };
    }
  }
  return {
    apiCall,
  };
}
